import React from 'react';
import { HealthScores } from "@/routes/(pharma)/_layout/inventory/-data/model";
import StockAvailabilityScore from './stock_availability_score';
import InventoryTurnoverScore from './inventory_turnover_score';
import { Separator } from '@/components/ui/separator';
import { HealthScore } from '@/gen/inventory/common_pb';

interface HealthScoresCardProps {
  healthScores: HealthScore;
}

const HealthScoresCard: React.FC<HealthScoresCardProps> = ({ healthScores }) => {
  return (
    <div className="col-span-2 w-full my-4">
      <p className='text-xl font-semibold text-gray-600 mb-4'>Health Scores</p>
      <div className="flex flex-row gap-4">
        <div className="py-4 flex-1">
          <StockAvailabilityScore percent={healthScores.stockAvailabilityScore} />
        </div>
        <Separator orientation='vertical' className='h-24' />
        <div className="py-4 flex-1">
          <InventoryTurnoverScore percent={healthScores.inventoryTurnoverScore} />
        </div>
      </div>
    </div>
  );
};

export default HealthScoresCard; 